import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetStaticFaqsRequestValueObject extends ValueObject {
  #path

  static validate({path}) {
    if (typeof path !== 'string') {
      throw InvalidParamsSharedError.create(
        `[GetStaticFaqsRequestValueObject.validate] param(${path}) should be a string`
      )
    }
  }

  static create({path}) {
    GetStaticFaqsRequestValueObject.validate({path})
    return new GetStaticFaqsRequestValueObject({path})
  }

  constructor({path}) {
    super()
    this.#path = path
  }

  get path() {
    return this.#path
  }

  isEmpty() {
    return this.#path === '' || this.#path === null
  }

  toJSON() {
    return {path: this.#path}
  }
}
